import { axiosInstance } from '@/http-common'
import { getCompanyFromJwt } from '@/crud/getters'

function isNotEmpty(value: any): boolean {
    return value !== undefined && value !== null && value !== ''
}

interface LoadParams {
    skip?: number
    take?: number
    sort?: any
    filter?: any
}

export async function getNotificationsSettingsList(params: LoadParams = {}): Promise<any> {
    const queryParams: any = {}

    if (isNotEmpty(params.skip)) queryParams.skip = params.skip
    if (isNotEmpty(params.take)) queryParams.take = params.take

    if (isNotEmpty(params.sort)) {
        queryParams.sort = JSON.stringify(params.sort)
    }

    if (isNotEmpty(params.filter)) {
        queryParams.filter = JSON.stringify(params.filter)
    }

    const companyId = getCompanyFromJwt()

    if (companyId) {
        queryParams.companyId = companyId
    }

    return axiosInstance
        .get('/api/v1/devices', { params: queryParams })
        .then(response => {
            const data = response.data.data.result.map((item: any) => {
                const notificationSettings = item.notification_settings || {
                    send_by_email: true,
                    send_by_sms: true,
                    send_by_mercure: true,
                }

                return {
                    ...item,
                    notification_settings: notificationSettings,
                }
            })

            return {
                data: data,
                totalCount: response.data.totalCount,
            }
        })
}
